import { useEffect, useState } from "react";
import { Arrow, Circle, Image, Layer, Rect, Stage, Text } from "react-konva";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ProcedureMoveAppBar from "../../../common/ProcedureMoveAppBar.js";
import Snackbar from "../../../common/Snackbar.js";
import { moveStep } from "../../../redux/stepSlice.js";
import { copyElement } from "../../../redux/sectionSlice.js";
import { generateSHA256 } from "../../../util/generateSHA256.js";
import { getPages, renderPreview, renderVideo } from "../plugins/utils.js";

import { generateConfirmMoveMessage } from "../../SubassemblyDetails/utils/movePreviewUtils.js";
import {

  HeadingWithTreePath,
} from "../../SubassemblyDetails/utils/treePathUtils.js";
import RenderHtml from "../../../common/AppSpecificConpnents/PartsTable/RenderHtml.js";
import CanvasDisplay from "../../Canvas/components/canvas-core/CanvasDisplay.jsx";
import {
  extractVersionStructure,
  getAuditTrailData,
  prepareNewContent,
} from "../../../util/getAuditTrailData.js";
import { getRevAllNodes } from "../../../redux/procedureRevisionSlice.js";
import { getMoveCopyText } from "../../../util/AppUtils.js";
const ProcedureCanvasMovePreview = () => {
  const { sections } = useSelector((state) => state.section);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let richTextCounter = 1;
  let canvasCounter = 1;
  let videoCounter = 1;
  let formCounter = 1;

  // Helper function to render canvas content
  const renderCanvas = (canvasItem) => {
    if (!canvasItem) return null;

    return (
      <div className="canvas-preview">
        <div className="canvas-description">{canvasItem.short_description}</div>
        <div className="canvas-content" style={{ marginTop: "10px" }}>
          <Stage
            width={400}
            height={300}
            style={{
              background: "white",
              border: "1px solid #DEE2E6",
              boxShadow: "0 0 10px rgba(0,0,0,0.1)",
            }}
          >
            <Layer>
              {(canvasItem.shapes || []).map((shape, i) => {
                const info = shape.shape_info || {};

                // Render rectangles
                if (shape.type === "rectangle") {
                  return (
                    <Rect
                      key={shape.shape_id || i}
                      x={info.x || 0}
                      y={info.y || 0}
                      width={info.width || 0}
                      height={info.height || 0}
                      fill={info.fillColor || "#cccccc"}
                    />
                  );
                }

                // Render text
                if (shape.type === "text") {
                  return (
                    <Text
                      key={shape.shape_id || i}
                      x={info.x || 0}
                      y={info.y || 0}
                      text={info.part || ""}
                      fontSize={info.textStyles?.fontSize || 14}
                      fill={info.textStyles?.fill || "#000000"}
                      fontStyle={info.textStyles?.fontWeight || "normal"}
                    />
                  );
                }

                // Render circles
                if (shape.type === "circle") {
                  return (
                    <Circle
                      key={shape.shape_id || i}
                      x={info.x || 0}
                      y={info.y || 0}
                      radius={info.radius || 0}
                      fill={info.fillColor || "#cccccc"}
                      stroke={info.strokeColor || "#000000"}
                      strokeWidth={info.strokeSize || 0}
                    />
                  );
                }

                // Render arrows
                if (shape.type === "arrow") {
                  return (
                    <Arrow
                      key={shape.shape_id || i}
                      points={[
                        info.x || 0,
                        info.y || 0,
                        info.x2 || 0,
                        info.y2 || 0,
                      ]}
                      fill={info.fillColor || "#cccccc"}
                      stroke={info.strokeColor || "#000000"}
                      strokeWidth={info.strokeSize || 0}
                    />
                  );
                }

                // Render images
                if (shape.type === "image") {
                  return (
                    <Image
                      key={shape.shape_id || i}
                      x={info.x || 0}
                      y={info.y || 0}
                      width={info.width || 100}
                      height={info.height || 100}
                      image={new window.Image()} // src of the image (empty here for preview)
                      offsetX={info.offsetX || 0}
                      offsetY={info.offsetY || 0}
                    />
                  );
                }

                return null;
              })}
            </Layer>
          </Stage>
        </div>
      </div>
    );
  };

  let substepCounter = 1;
  let stepCounter = 1;
  const [isLoading, setIsLoading] = useState(false);
  const [isModalLoading, setIsModalLoading] = useState(false);
  const [auditData, setAuditData] = useState({
    user_ref: localStorage.getItem("user_id") || "",
    ip_address: "",
    device_info: navigator.userAgent,
    hash: generateSHA256(Math.random().toString()),
    signature: "",
  }); // Fetch IP address and generate hash

  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((res) => res.json())
      .then((data) =>
        setAuditData((prev) => ({ ...prev, ip_address: data.ip }))
      )
      .catch((err) => {});
  }, []);

  let richTextsCounter = {};
  let attachmentCounter = 1;
  const [isModalOpen, setModalOpen] = useState(false);
  const [comment, setComment] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    type: "",
  });
  const {
    stepsBySection,
    substepsByStep,
    richTexts,
    attachments,
    forms,
    canvases,
    videos,
  } = useSelector((state) => state.step);

  const [selectedView, setSelectedView] = useState("new");

  // Handle view mode change
  const handleViewChange = (view) => {
    setSelectedView(view);
  };

  const {
    moveType,
    sourceSectionIndex,
    targetSectionIndex,
    revision,
    partNumber,
    type,
    sourceStepIndex,
    steps,
    targetStepIndex = 0, // Default value if not provided
    targetNodeIndex, // Add this missing variable
    partId,
    revisionId,
    fromStepId,
    fromSubstepTreeId,
    fromSubstepSiblingOrder,
    targetSectionData,
    fromSectionId,
    fromSubstepId,
    targetNodeType,
    elementId,
    elementTreeId,
    createCopy = false,
  } = location.state;

  const [previewSections, setPreviewSections] = useState([...sections]);
  const sortedSections = [...sections];

  const { allRevisionNodes } = useSelector((state) => state.procedureRevision);
  useEffect(() => {
    if (elementId) {
      dispatch(
        getRevAllNodes({
          partId: partId,
          revisionId: revisionId,
        })
      );
    }
  }, [dispatch, elementId, partId, revisionId]);
  // Ensure we have sourceStepId available
  useEffect(() => {
    // Make sure we have a valid sourceStepId
    if (
      location.state.movingNode &&
      !location.state.sourceStepId &&
      sourceStepIndex !== undefined
    ) {
      const sourceSectionId =
        sortedSections[sourceSectionIndex]?.section_tree_node_id;
      const sourceSteps = stepsBySection[sourceSectionId] || [];
      const sourceStep = sourceSteps[sourceStepIndex] || {};

      if (sourceStep.step_tree_node_id) {
        location.state.sourceStepId = sourceStep.step_tree_node_id;
      } else if (steps && steps.length > 0) {
        location.state.sourceStepId = steps[0].step_tree_node_id;
      }
    }
  }, [
    sourceStepIndex,
    sourceSectionIndex,
    stepsBySection,
    sortedSections,
    steps,
    location.state,
  ]);

  useEffect(() => {
    // Create preview of the move
    const newSections = [...sections];

    if (location.state.movingNode) {
      // Parse the step number and canvas number from the title
      let sourceStepNumber = null;
      let sourceCanvasNumber = null;

      // Check if we have the title and extract numbers
      if (location.state.title) {
        // Handle both patterns: "Canvas X from Step Y" and potential "NaN" cases
        const titleMatch = location.state.title.match(
          /Canvas (\d+) from Step ([0-9]+|NaN)/i
        );
        if (titleMatch) {
          sourceCanvasNumber = parseInt(titleMatch[1], 10);
          // Only parse the step number if it's not "NaN"
          if (titleMatch[2] !== "NaN") {
            sourceStepNumber = parseInt(titleMatch[2], 10);
          }
        }
      }

      // Look for step number in various locations
      if (!sourceStepNumber || isNaN(sourceStepNumber)) {
        // Try location.state.stepNumber
        if (
          location.state.stepNumber &&
          !isNaN(parseInt(location.state.stepNumber, 10))
        ) {
          sourceStepNumber = parseInt(location.state.stepNumber, 10);
        }
        // If still not found, use sourceStepIndex + 1
        else if (sourceStepIndex !== undefined) {
          sourceStepNumber = sourceStepIndex + 1;
        }
      }

      // Look for canvas number in various locations
      if (!sourceCanvasNumber || isNaN(sourceCanvasNumber)) {
        // Try location.state.canvasNumber
        if (
          location.state.canvasNumber &&
          !isNaN(parseInt(location.state.canvasNumber, 10))
        ) {
          sourceCanvasNumber = parseInt(location.state.canvasNumber, 10);
        }
        // Try to extract from title using alternative pattern
        else {
          const matches = location.state.title
            ? location.state.title.match(/Canvas\s+(\d+)/i)
            : null;
          if (matches && matches[1]) {
            sourceCanvasNumber = parseInt(matches[1], 10);
          } else {
            // If all else fails, use sourceNodeIndex + 1
            sourceCanvasNumber = location.state.sourceNodeIndex + 1;
          }
        }
      }

      // For attachment moves, derive sourceStepId if not in location.state
      if (!location.state.sourceStepId && sourceStepIndex !== undefined) {
        // Get the source step and use its ID
        const sourceSectionId =
          sortedSections[sourceSectionIndex]?.section_tree_node_id;
        const sourceSteps = stepsBySection[sourceSectionId] || [];
        const sourceStep = sourceSteps[sourceStepIndex] || {};

        // Store it back in location.state for future reference
        location.state.sourceStepId = sourceStep.step_tree_node_id;
      }
    } else if (location.state.movingStep) {
      // For step moves, existing implementation
      const sourceSection = newSections[sourceSectionIndex];
      newSections.splice(sourceSectionIndex, 1);
      newSections.splice(targetSectionIndex, 0, sourceSection);
      setPreviewSections(newSections);
    } else {
      // Original section move logic
      const sourceSection = newSections[sourceSectionIndex];
      newSections.splice(sourceSectionIndex, 1);
      newSections.splice(targetSectionIndex, 0, sourceSection);
      setPreviewSections(newSections);
    }
  }, [
    sourceSectionIndex,
    targetSectionIndex,
    moveType,
    sourceStepIndex,
    location.state.targetStepIndex,
    location.state.targetNodeIndex,
    location.state.movingNode,
    location.state.movingStep,
  ]);

  const showSnackbar = (message, type) => {
    setSnackbar({ open: true, message, type });
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleConfirm = () => {
    setModalOpen(true);
  };

  const compareSiblingOrders = (a, b) => {
    const intA = parseInt(a, 10);
    const intB = parseInt(b, 10);
    return intA - intB;
  };

  const handleConfirmSave = async () => {
    if (!comment.trim()) {
      showSnackbar("Please enter a comment before confirming.", "error");
      return;
    }

    setIsModalLoading(true);
    try {
      const targetContainerId =
        targetSectionData?.substepId || targetSectionData?.stepId;

      let parent_version = Object.values(canvases)
        .flat()
        .find((a) => a.canvas_tree_node_id === elementId);

      const newContent = prepareNewContent({
        allRevisionNodes,
        fromInfo: {
          fromSectionId,
          fromStepId,
          fromSubstepId,
          nodeId: elementId,
        },
        toInfo: { ...targetSectionData },
        moveType,
        node_id_key: "canvas_tree_node_id",
      });
      const audit_trail_data = await getAuditTrailData(
        {
          action: createCopy ? "CANVAS_COPIED" : "CANVAS_MOVED",
          comment: comment,
          parent_version: parent_version ? parent_version.version_id_ref : null,
          version_content: {
            action_to_show: getMoveCopyText(
              location.state.move_rev_node_info,
              partNumber,
              revision
            ),
            originingalContent: extractVersionStructure(allRevisionNodes),
            newContent: newContent,
            moveType,
            rev: revision,
            status: location.state.status,
            type,
            item_code_type: type,
            partNumber,
          },
        },
        false
      );
      // Prepare payload for moving canvas
      const stepData = {
        from_procedure_tree_node_ref: fromSubstepTreeId,
        from_order: parseInt(fromSubstepSiblingOrder),
        from_type: "canva",
        from_part_id_ref: partId,
        from_procedure_rev_ref: revisionId,
        from_section_id_ref: fromSectionId,
        from_step_id_ref: fromStepId,
        from_substep_id_ref: fromSubstepId === "null" ? null : fromSubstepId,
        to_procedure_tree_node_ref: targetSectionData?.elementTreeId,
        to_order: (() => {
          // For "into" moves, this will be calculated later
          if (moveType === "into") {
            return 0; // Placeholder, will be calculated below
          }

          // CRITICAL FIX: Use the expectedSiblingOrder that was calculated in the move function
          // This ensures the save logic matches exactly what the preview shows
          if (location.state.expectedSiblingOrder !== undefined) {
            return location.state.expectedSiblingOrder;
          }

          // Fallback: use the base order calculation if expectedSiblingOrder is not available
          const baseOrder = parseInt(
            targetSectionData?.elementSiblingOrder ||
              targetSectionData?.substepSiblingOrder ||
              targetSectionData?.stepSiblingOrder ||
              1
          );

          if (moveType === "up") {
            return baseOrder;
          } else if (moveType === "below") {
            return baseOrder + 1;
          }

          return baseOrder;
        })(),
        to_type: "canva", // Always use the source item type (canvas), not the target type
        to_part_id_ref: partId,
        to_procedure_rev_ref: revisionId,
        to_section_id_ref: targetSectionData?.sectionId,
        to_step_id_ref: targetSectionData?.stepId,
        to_substep_id_ref: targetSectionData?.substepId,
        from_child_node_ref: location.state.elementId,
        to_child_node_ref: targetSectionData?.elementId,
        direction_move_into: Boolean(
          moveType === "into" ||
            fromStepId !== targetSectionData?.stepId ||
            (fromSubstepId &&
              targetSectionData?.substepId &&
              fromSubstepId !== targetSectionData?.substepId)
        ),
        direction:
          moveType === "up"
            ? createCopy
              ? "paste_up"
              : "move_up"
            : moveType === "below"
            ? createCopy
              ? "paste_down"
              : "move_down"
            : createCopy
            ? "paste_down"
            : "move_down",
        ...(createCopy ? {} : { create_copy: createCopy }), // Only add create_copy for move operations
        audit_trail_data,
      };

      // Clean up empty or null substep ref
      if (!stepData.from_substep_id_ref) {
        delete stepData.from_substep_id_ref;
      }

      // Clean up empty or null substep ref
      if (!stepData.to_substep_id_ref) {
        delete stepData.to_substep_id_ref;
      }

      if (moveType === "into") {
        // For moving into, we need to calculate the highest sibling_order in the target container
        // and set to_order to (highest + 1) to place the rich text at the end

        // Get all items in the target container
        let targetItems = [];

        if (targetSectionData?.substepId) {
          // If target is a substep, get all items in that substep
          targetItems = [
            ...(richTexts[targetSectionData.substepId] || []),
            ...(forms[targetSectionData.substepId] || []),
            ...(attachments[targetSectionData.substepId] || []),
            ...(canvases[targetSectionData.substepId] || []),
            ...(videos[targetSectionData.substepId] || []),
          ];
        } else if (targetSectionData?.stepId) {
          // If target is a step, get all items in that step (excluding substep items)
          const allStepItems = [
            ...(richTexts[targetSectionData.stepId] || []),
            ...(forms[targetSectionData.stepId] || []),
            ...(attachments[targetSectionData.stepId] || []),
            ...(canvases[targetSectionData.stepId] || []),
            ...(videos[targetSectionData.stepId] || []),
          ];

          // Filter out items that belong to substeps
          targetItems = allStepItems.filter(
            (item) => !item.substep_id_ref && !item.sub_step_tree_node_id
          );
        }

        // Find the highest sibling_order in the target items
        let highestOrder = 0;
        targetItems.forEach((item) => {
          const order = parseInt(
            item.sibling_order || item.procedure_tree?.sibling_order || 0
          );
          if (!isNaN(order) && order > highestOrder) {
            highestOrder = order;
          }
        });

        // Set to_order to highest + 1 (or at least 1 if no items)
        stepData.to_order = Math.max(1, highestOrder + 1);
      }

      // Call API to update the canvas position
      if (createCopy) {
        // Use copyElement action for copy operations
        await dispatch(copyElement(stepData)).unwrap();
      } else {
        // Use moveStep action for move operations
        await dispatch(moveStep(stepData)).unwrap();
      }

      showSnackbar(
        createCopy
          ? "Canvas copied successfully!"
          : "Canvas moved successfully!",
        "success"
      );

      setModalOpen(false);
      navigate(-3); // Navigate back to the previous page
    } catch (error) {
      showSnackbar("Error during move operation: " + error.message, "error");
    } finally {
      setIsModalLoading(false);
    }
  };

  const getReorderedStepsBySection = (
    stepsBySection,
    sortedSections,
    sourceSectionIndex,
    targetSectionIndex,
    sourceStepIndex,
    targetStepIndex,
    moveType,
    movingStep = false
  ) => {
    if (selectedView === "original") return stepsBySection;

    // Clone the existing structure to avoid mutating state directly
    const updatedStepsBySection = JSON.parse(JSON.stringify(stepsBySection));

    if (movingStep) {
      // Get the source section ID
      const sourceSectionId = sortedSections.find(
        (s) => s.section_tree_node_id === sourceSectionIndex
      )?.section_tree_node_id;
      if (!sourceSectionId) return updatedStepsBySection;

      // Get the target section ID
      const targetSectionId =
        sortedSections[targetSectionIndex].section_tree_node_id;

      // Get the source steps array and the step to move
      const sourceSteps = [...(updatedStepsBySection[sourceSectionId] || [])];
      if (sourceStepIndex >= sourceSteps.length) return updatedStepsBySection;

      // Remove step from source
      const [movedStep] = sourceSteps.splice(sourceStepIndex, 1);

      // Get the target steps array
      const targetSteps = [...(updatedStepsBySection[targetSectionId] || [])];

      // Handle different move types
      if (moveType === "into") {
        // Move to end of target section
        targetSteps.push(movedStep);
      } else if (moveType === "up") {
        // Insert before the target step
        targetSteps.splice(targetStepIndex, 0, movedStep);
      } else if (moveType === "below") {
        // Insert after the target step
        targetSteps.splice(targetStepIndex + 1, 0, movedStep);
      }

      // Update the mappings
      updatedStepsBySection[sourceSectionId] = sourceSteps;
      updatedStepsBySection[targetSectionId] = targetSteps;

      return updatedStepsBySection;
    } else {
      // Original section moving logic - just return the original for now
      // as we're only focusing on step movement
      const newStepsBySection = { ...stepsBySection };
      return newStepsBySection;
    }
  };

  const updated = getReorderedStepsBySection(
    stepsBySection,
    sections,
    sourceSectionIndex,
    targetSectionIndex,
    sourceStepIndex,
    location.state.targetStepIndex,
    moveType,
    location.state.movingStep
  );

  const updatedSubstepsByStep = substepsByStep;

  // Set up the preview data for the UI
  const updatedSteps = location.state.movingStep
    ? getReorderedStepsBySection(
        stepsBySection,
        sections,
        sourceSectionIndex,
        targetSectionIndex,
        sourceStepIndex,
        location.state.targetStepIndex,
        moveType,
        location.state.movingStep
      )
    : stepsBySection;

  const getReorganizedContentItems = (
    allContentItems, // { stepId or substepId: array of items }
    sourceStepId,
    targetStepId,
    sourceNodeIndex,
    targetNodeIndex,
    moveType,
    nodeType // "richText", "form", "attachment", etc.
  ) => {
    if (selectedView === "original" || !location.state.movingNode) {
      return allContentItems;
    }

    // If sourceStepId is missing, try to derive it
    if (!sourceStepId && sourceStepIndex !== undefined) {
      const sourceSectionId =
        sortedSections[sourceSectionIndex]?.section_tree_node_id;
      const sourceSteps = stepsBySection[sourceSectionId] || [];
      const sourceStep = sourceSteps[sourceStepIndex] || {};
      sourceStepId = sourceStep.step_tree_node_id;
    }

    // If we still don't have sourceStepId, check if we're moving to the same step (from a substep)
    if (!sourceStepId && targetStepId) {
      sourceStepId = targetStepId;
    }

    // If sourceStepId is still missing but we have steps from location.state
    if (!sourceStepId && steps && steps.length > 0) {
      sourceStepId = steps[0].step_tree_node_id;
    }

    if (!sourceStepId || !targetStepId) {
      return allContentItems; // Return original items without changes
    }

    const updatedItems = JSON.parse(JSON.stringify(allContentItems));

    // Get source container ID (either substep ID or step ID)
    let sourceContainerId = null;
    if (location.state.sourceSubstepIndex !== undefined) {
      // For substep source
      const substeps = substepsByStep[sourceStepId] || [];
      const sourceSubstep = substeps[location.state.sourceSubstepIndex];
      sourceContainerId = sourceSubstep?.sub_step_tree_node_id;
    } else {
      // For step source
      sourceContainerId = sourceStepId;
    }

    // Get target container ID (either substep ID or step ID)
    let targetContainerId = null;
    if (location.state.targetSubstepIndex !== undefined) {
      // For substep target
      const substeps = substepsByStep[targetStepId] || [];
      const targetSubstep = substeps[location.state.targetSubstepIndex];
      targetContainerId = targetSubstep?.sub_step_tree_node_id;
    } else {
      // For step target
      targetContainerId = targetStepId;
    }

    // Define these variables early so they can be used throughout the function
    const isSourceSubstep = location.state.sourceSubstepIndex !== undefined;
    const isTargetSubstep = location.state.targetSubstepIndex !== undefined;

    // If we're missing a source container but have a target, try to find the actual item first
    if (!sourceContainerId && targetContainerId) {
      // Try to find the actual item in the source step first
      let actualItemToMove = null;
      if (sourceStepId) {
        // Look for the item in the source step
        const sourceStepItems = updatedItems[sourceStepId] || [];
        const visibleSourceItems = sourceStepItems.filter((item) => {
          const isMatch =
            item.type === nodeType &&
            !item.substep_id_ref &&
            !item.sub_step_tree_node_id;
          return isMatch;
        });

        if (sourceNodeIndex < visibleSourceItems.length) {
          actualItemToMove = visibleSourceItems[sourceNodeIndex];
        }
      }

      // If we found the actual item, move it instead of creating a placeholder
      if (actualItemToMove) {
        if (createCopy) {
          // For copy, create a deep copy without removing from source
          const actualItemToMoveCopy = JSON.parse(
            JSON.stringify(actualItemToMove)
          );

          // Generate new unique IDs
          const timestamp = Date.now();
          if (actualItemToMoveCopy.canvas_tree_node_id) {
            actualItemToMoveCopy.canvas_tree_node_id = `${actualItemToMoveCopy.canvas_tree_node_id}_copy_${timestamp}`;
          }
          if (actualItemToMoveCopy.rich_text_node_id) {
            actualItemToMoveCopy.rich_text_node_id = `${actualItemToMoveCopy.rich_text_node_id}_copy_${timestamp}`;
          }
          if (actualItemToMoveCopy.form_tree_node_id) {
            actualItemToMoveCopy.form_tree_node_id = `${actualItemToMoveCopy.form_tree_node_id}_copy_${timestamp}`;
          }
          if (actualItemToMoveCopy.attachment_tree_node_id) {
            actualItemToMoveCopy.attachment_tree_node_id = `${actualItemToMoveCopy.attachment_tree_node_id}_copy_${timestamp}`;
          }
          if (actualItemToMoveCopy.video_tree_node_id) {
            actualItemToMoveCopy.video_tree_node_id = `${actualItemToMoveCopy.video_tree_node_id}_copy_${timestamp}`;
          }

          // Use the copy for the target
          actualItemToMove = actualItemToMoveCopy;
        } else {
          // Remove from source
          const sourceStepItems = updatedItems[sourceStepId] || [];
          const itemIndexInList = sourceStepItems.indexOf(actualItemToMove);
          if (itemIndexInList !== -1) {
            sourceStepItems.splice(itemIndexInList, 1);
            updatedItems[sourceStepId] = sourceStepItems;
          }
        }

        // Prepare item for target
        if (isTargetSubstep) {
          actualItemToMove.substep_id_ref = targetContainerId;
          actualItemToMove.sub_step_tree_node_id = targetContainerId;
        } else {
          delete actualItemToMove.substep_id_ref;
          delete actualItemToMove.sub_step_tree_node_id;
        }

        // Add to target
        const targetItems = updatedItems[targetContainerId] || [];

        if (moveType === "into") {
          targetItems.push(actualItemToMove);
        } else {
          // For "up" or "below" moves
          // When moving above/below, we need to consider ALL items in the container, not just items of the same type
          const visibleTargetItems = targetItems.filter((item) => {
            const containerMatches = isTargetSubstep
              ? item.sub_step_tree_node_id === targetContainerId
              : !item.substep_id_ref && !item.sub_step_tree_node_id;
            return containerMatches;
          });

          let insertIndex = targetItems.length;

          if (
            targetNodeIndex !== undefined &&
            targetNodeIndex < visibleTargetItems.length
          ) {
            const targetItem = visibleTargetItems[targetNodeIndex];
            const targetItemIndex = targetItems.indexOf(targetItem);

            if (targetItemIndex !== -1) {
              if (moveType === "up") {
                insertIndex = targetItemIndex;
              } else if (moveType === "below") {
                insertIndex = targetItemIndex + 1;
              }
            }
          }

          // Enhanced positioning logic for better accuracy
          if (
            insertIndex === targetItems.length &&
            location.state.targetNodeType
          ) {
            // Look for the target item by its type and properties
            const targetItemType = location.state.targetNodeType.toLowerCase();
            const targetItemId = location.state.targetNodeId;

            if (targetItemId) {
              // Try to find by ID first
              const targetById = targetItems.find((item) => {
                if (!item) return false;
                const itemId =
                  item.video_tree_node_id ||
                  item.rich_text_node_id ||
                  item.form_tree_node_id ||
                  item.canvas_tree_node_id ||
                  item.attachment_tree_node_id;
                return itemId === targetItemId;
              });

              if (targetById) {
                const targetIndex = targetItems.indexOf(targetById);
                if (targetIndex !== -1) {
                  insertIndex =
                    moveType === "up" ? targetIndex : targetIndex + 1;
                }
              }
            }

            // If still no match, try by type and global number
            if (
              insertIndex === targetItems.length &&
              location.state.targetNodeGlobalNumber
            ) {
              const targetByType = targetItems.find((item) => {
                if (!item) return false;
                const itemType =
                  item.type ||
                  (item.video_tree_node_id
                    ? "video"
                    : item.rich_text_node_id
                    ? "richText"
                    : item.form_tree_node_id
                    ? "form"
                    : item.canvas_tree_node_id
                    ? "canvas"
                    : item.attachment_tree_node_id
                    ? "attachment"
                    : null);
                return itemType === targetItemType;
              });

              if (targetByType) {
                const targetIndex = targetItems.indexOf(targetByType);
                if (targetIndex !== -1) {
                  insertIndex =
                    moveType === "up" ? targetIndex : targetIndex + 1;
                }
              }
            }
          }

          targetItems.splice(insertIndex, 0, actualItemToMove);
        }

        updatedItems[targetContainerId] = targetItems;
        return updatedItems;
      }

      // Only create placeholder if we couldn't find the actual item

      // Create a placeholder item based on the node type
      const placeholderItem = {
        type: nodeType,
        short_description: `${
          nodeType.charAt(0).toUpperCase() + nodeType.slice(1)
        } ${sourceNodeIndex + 1} from Step ${
          sourceStepIndex + 1
        } (placeholder)`,
      };

      // Add type-specific properties
      if (nodeType === "attachment") {
        placeholderItem.attachment_tree_node_id = `temp-attachment-${Date.now()}`;
        placeholderItem.attachments = [];
      } else if (nodeType === "richText") {
        placeholderItem.rich_text_node_id = `temp-richtext-${Date.now()}`;
        placeholderItem.rich_text_content = "<p>Moved content</p>";
        placeholderItem.category_data = { category_name: "" };
      } else if (nodeType === "form") {
        placeholderItem.form_tree_node_id = `temp-form-${Date.now()}`;
      } else if (nodeType === "canvas") {
        placeholderItem.canvas_tree_node_id = `temp-canvas-${Date.now()}`;
        placeholderItem.shapes = [];
      } else if (nodeType === "video") {
        placeholderItem.video_tree_node_id = `temp-video-${Date.now()}`;
        placeholderItem.video = "";
        placeholderItem.video_url = "";
      }

      // Add to target based on move type
      const targetItems = updatedItems[targetContainerId] || [];

      if (moveType === "into") {
        // For "into" moves, just add to the end
        targetItems.push(placeholderItem);
      } else {
        // For "up" or "below" moves, we need to insert at the correct position
        // When moving above/below, we need to consider ALL items in the container

        // When moving above/below, we need to consider ALL items in the container, not just items of the same type
        const visibleTargetItems = targetItems.filter((item) => {
          // Match container (step or substep)
          const containerMatches = isTargetSubstep
            ? item.sub_step_tree_node_id === targetContainerId
            : !item.substep_id_ref && !item.sub_step_tree_node_id;

          return containerMatches;
        });

        let insertIndex = targetItems.length; // Default to end of list

        // If we have a target node index and enough items
        if (
          targetNodeIndex !== undefined &&
          targetNodeIndex < visibleTargetItems.length
        ) {
          const targetItem = visibleTargetItems[targetNodeIndex];

          const targetItemIndex = targetItems.indexOf(targetItem);

          if (targetItemIndex !== -1) {
            // Insert before (up) or after (below) the target
            if (moveType === "up") {
              insertIndex = targetItemIndex;
            } else if (moveType === "below") {
              insertIndex = targetItemIndex + 1;
            }
          }
        } else {
        }

        // Enhanced positioning logic for better accuracy
        if (
          insertIndex === targetItems.length &&
          location.state.targetNodeType
        ) {
          // Look for the target item by its type and properties
          const targetItemType = location.state.targetNodeType.toLowerCase();
          const targetItemId = location.state.targetNodeId;

          if (targetItemId) {
            // Try to find by ID first
            const targetById = targetItems.find((item) => {
              if (!item) return false;
              const itemId =
                item.video_tree_node_id ||
                item.rich_text_node_id ||
                item.form_tree_node_id ||
                item.canvas_tree_node_id ||
                item.attachment_tree_node_id;
              return itemId === targetItemId;
            });

            if (targetById) {
              const targetIndex = targetItems.indexOf(targetById);
              if (targetIndex !== -1) {
                insertIndex = moveType === "up" ? targetIndex : targetIndex + 1;
              }
            }
          }

          // If still no match, try by type and global number
          if (
            insertIndex === targetItems.length &&
            location.state.targetNodeGlobalNumber
          ) {
            const targetByType = targetItems.find((item) => {
              if (!item) return false;
              const itemType =
                item.type ||
                (item.video_tree_node_id
                  ? "video"
                  : item.rich_text_node_id
                  ? "richText"
                  : item.form_tree_node_id
                  ? "form"
                  : item.canvas_tree_node_id
                  ? "canvas"
                  : item.attachment_tree_node_id
                  ? "attachment"
                  : null);
              return itemType === targetItemType;
            });

            if (targetByType) {
              const targetIndex = targetItems.indexOf(targetByType);
              if (targetIndex !== -1) {
                insertIndex = moveType === "up" ? targetIndex : targetIndex + 1;
              }
            }
          }
        }

        // Insert at the calculated position
        targetItems.splice(insertIndex, 0, placeholderItem);
      }

      updatedItems[targetContainerId] = targetItems;
      return updatedItems;
    } else if (!sourceContainerId || !targetContainerId) {
      return updatedItems;
    }

    const sourceItems = updatedItems[sourceContainerId] || [];

    // Filter for visible items of matching type
    const visibleSourceItems = sourceItems.filter((item) => {
      const isMatch =
        item.type === nodeType &&
        (isSourceSubstep ||
          (!item.substep_id_ref && !item.sub_step_tree_node_id));
      return isMatch;
    });

    // If there are too few items in source, try looking for any type
    if (visibleSourceItems.length <= sourceNodeIndex) {
      // If nodeType is 'attachment' but we can't find it, look for any node type
      const allVisibleItems = sourceItems.filter(
        (item) =>
          isSourceSubstep ||
          (!item.substep_id_ref && !item.sub_step_tree_node_id)
      );

      // If we still don't have enough items, try looking in other steps
      if (sourceNodeIndex >= allVisibleItems.length) {
        // Try to find the attachment in the correct source step
        if (
          location.state.sourceStepIndex !== undefined &&
          sourceStepIndex !== undefined
        ) {
          const sourceSectionId =
            sortedSections[sourceSectionIndex]?.section_tree_node_id;
          const sourceSteps = stepsBySection[sourceSectionId] || [];

          // Get step ID from the correct index
          if (sourceStepIndex < sourceSteps.length) {
            const correctSourceStep = sourceSteps[sourceStepIndex];
            const correctSourceStepId = correctSourceStep.step_tree_node_id;
            if (
              correctSourceStepId &&
              correctSourceStepId !== sourceContainerId
            ) {
              // Get items from this step
              const correctSourceItems =
                updatedItems[correctSourceStepId] || [];

              // Filter for the right type
              const correctVisibleItems = correctSourceItems.filter(
                (item) =>
                  item.type === nodeType &&
                  !item.substep_id_ref &&
                  !item.sub_step_tree_node_id
              );

              if (sourceNodeIndex < correctVisibleItems.length) {
                // Found the item in the correct source step
                const correctItemToMove = correctVisibleItems[sourceNodeIndex];
                const correctItemIndex =
                  correctSourceItems.indexOf(correctItemToMove);

                if (correctItemIndex !== -1) {
                  // Remove from source
                  correctSourceItems.splice(correctItemIndex, 1);
                  updatedItems[correctSourceStepId] = correctSourceItems;

                  // Prepare for target
                  if (isTargetSubstep) {
                    correctItemToMove.substep_id_ref = targetContainerId;
                    correctItemToMove.sub_step_tree_node_id = targetContainerId;
                  } else {
                    delete correctItemToMove.substep_id_ref;
                    delete correctItemToMove.sub_step_tree_node_id;
                  }

                  // Add to target
                  const targetItems = updatedItems[targetContainerId] || [];

                  if (moveType === "into") {
                    // For "into" moves, add to the end
                    targetItems.push(correctItemToMove);
                  } else {
                    // For "up" or "below" moves
                    // When moving above/below, we need to consider ALL items in the container, not just items of the same type
                    const visibleTargetItems = targetItems.filter((item) => {
                      const containerMatches = isTargetSubstep
                        ? item.sub_step_tree_node_id === targetContainerId
                        : !item.substep_id_ref && !item.sub_step_tree_node_id;
                      return containerMatches;
                    });

                    let insertIndex = targetItems.length;

                    if (
                      targetNodeIndex !== undefined &&
                      targetNodeIndex < visibleTargetItems.length
                    ) {
                      const targetItem = visibleTargetItems[targetNodeIndex];
                      const targetItemIndex = targetItems.indexOf(targetItem);

                      if (targetItemIndex !== -1) {
                        insertIndex =
                          moveType === "up"
                            ? targetItemIndex
                            : targetItemIndex + 1;
                      }
                    }

                    // Enhanced positioning logic for better accuracy
                    if (
                      insertIndex === targetItems.length &&
                      location.state.targetNodeType
                    ) {
                      // Look for the target item by its type and properties
                      const targetItemType =
                        location.state.targetNodeType.toLowerCase();
                      const targetItemId = location.state.targetNodeId;

                      if (targetItemId) {
                        // Try to find by ID first
                        const targetById = targetItems.find((item) => {
                          if (!item) return false;
                          const itemId =
                            item.video_tree_node_id ||
                            item.rich_text_node_id ||
                            item.form_tree_node_id ||
                            item.canvas_tree_node_id ||
                            item.attachment_tree_node_id;
                          return itemId === targetItemId;
                        });

                        if (targetById) {
                          const targetIndex = targetItems.indexOf(targetById);
                          if (targetIndex !== -1) {
                            insertIndex =
                              moveType === "up" ? targetIndex : targetIndex + 1;
                          }
                        }
                      }

                      // If still no match, try by type and global number
                      if (
                        insertIndex === targetItems.length &&
                        location.state.targetNodeGlobalNumber
                      ) {
                        const targetByType = targetItems.find((item) => {
                          if (!item) return false;
                          const itemType =
                            item.type ||
                            (item.video_tree_node_id
                              ? "video"
                              : item.rich_text_node_id
                              ? "richText"
                              : item.form_tree_node_id
                              ? "form"
                              : item.canvas_tree_node_id
                              ? "canvas"
                              : item.attachment_tree_node_id
                              ? "attachment"
                              : null);
                          return itemType === targetItemType;
                        });

                        if (targetByType) {
                          const targetIndex = targetItems.indexOf(targetByType);
                          if (targetIndex !== -1) {
                            insertIndex =
                              moveType === "up" ? targetIndex : targetIndex + 1;
                          }
                        }
                      }
                    }

                    targetItems.splice(insertIndex, 0, correctItemToMove);
                  }

                  updatedItems[targetContainerId] = targetItems;

                  return updatedItems;
                }
              }
            }
          }
        }
      }

      if (sourceNodeIndex < allVisibleItems.length) {
        let itemToMove = allVisibleItems[sourceNodeIndex];

        // Continue with this item...
        const itemIndexInList = sourceItems.indexOf(itemToMove);
        if (itemIndexInList === -1) {
          return updatedItems;
        }

        if (createCopy) {
          // For copy, create a deep copy without removing from source
          const itemToMoveCopy = JSON.parse(JSON.stringify(itemToMove));

          // Generate new unique IDs
          const timestamp = Date.now();
          if (itemToMoveCopy.canvas_tree_node_id) {
            itemToMoveCopy.canvas_tree_node_id = `${itemToMoveCopy.canvas_tree_node_id}_copy_${timestamp}`;
          }
          if (itemToMoveCopy.rich_text_node_id) {
            itemToMoveCopy.rich_text_node_id = `${itemToMoveCopy.rich_text_node_id}_copy_${timestamp}`;
          }
          if (itemToMoveCopy.form_tree_node_id) {
            itemToMoveCopy.form_tree_node_id = `${itemToMoveCopy.form_tree_node_id}_copy_${timestamp}`;
          }
          if (itemToMoveCopy.attachment_tree_node_id) {
            itemToMoveCopy.attachment_tree_node_id = `${itemToMoveCopy.attachment_tree_node_id}_copy_${timestamp}`;
          }
          if (itemToMoveCopy.video_tree_node_id) {
            itemToMoveCopy.video_tree_node_id = `${itemToMoveCopy.video_tree_node_id}_copy_${timestamp}`;
          }

          // Use the copy for the target
          itemToMove = itemToMoveCopy;
        } else {
          // Remove from source
          sourceItems.splice(itemIndexInList, 1);
          updatedItems[sourceContainerId] = sourceItems;
        }

        // Prepare item for target
        if (isTargetSubstep) {
          itemToMove.substep_id_ref = targetContainerId;
          itemToMove.sub_step_tree_node_id = targetContainerId;
        } else {
          delete itemToMove.substep_id_ref;
          delete itemToMove.sub_step_tree_node_id;
        }

        const targetItems = updatedItems[targetContainerId] || [];

        if (moveType === "into") {
          targetItems.push(itemToMove);
        } else {
          // When moving above/below, we need to consider ALL items in the container, not just items of the same type
          // This is because we want to position relative to the target item regardless of its type
          const visibleTargetItems = targetItems.filter((item) => {
            const containerMatches = isTargetSubstep
              ? item.sub_step_tree_node_id === targetContainerId
              : !item.substep_id_ref && !item.sub_step_tree_node_id;
            return containerMatches;
          });

          let insertIndex = targetItems.length; // Default to end of list

          // First try to find by nodeIndex directly (used by attachments)
          if (targetNodeIndex !== undefined) {
            // If we have a specific target item index (probably from global numbering)
            if (targetNodeIndex < visibleTargetItems.length) {
              // If the index is within the filtered list range
              const targetItem = visibleTargetItems[targetNodeIndex];
              const targetItemIndex = targetItems.indexOf(targetItem);

              if (targetItemIndex !== -1) {
                if (moveType === "up") {
                  insertIndex = targetItemIndex;
                } else if (moveType === "below") {
                  insertIndex = targetItemIndex + 1;
                }
              }
            } else {
              // If target is a specific node but index is out of range
              // Try to find by globalNodeNumber instead
              const targetGlobalNumber = location.state.targetNodeGlobalNumber;

              if (targetGlobalNumber) {
                // Find any item with the matching global number
                const matchingItem = visibleTargetItems.find(
                  (item) =>
                    item.globalNodeNumber === targetGlobalNumber ||
                    parseInt(item.nodeIndex) === parseInt(targetGlobalNumber)
                );

                if (matchingItem) {
                  const matchIndex = targetItems.indexOf(matchingItem);
                  if (matchIndex !== -1) {
                    if (moveType === "up") {
                      insertIndex = matchIndex;
                    } else if (moveType === "below") {
                      insertIndex = matchIndex + 1;
                    }
                  }
                } else {
                  // If we still can't find a match, try using the first item of the target type
                  if (visibleTargetItems.length > 0) {
                    const firstItem = visibleTargetItems[0];
                    const firstIndex = targetItems.indexOf(firstItem);
                    if (firstIndex !== -1) {
                      if (moveType === "up") {
                        insertIndex = firstIndex;
                      } else if (moveType === "below") {
                        insertIndex = firstIndex + 1;
                      }
                    }
                  }
                }
              } else {
              }
            }
          } else {
          }

          // Enhanced positioning logic for better accuracy
          if (
            insertIndex === targetItems.length &&
            location.state.targetNodeType
          ) {
            // Look for the target item by its type and properties
            const targetItemType = location.state.targetNodeType.toLowerCase();
            const targetItemId = location.state.targetNodeId;

            if (targetItemId) {
              // Try to find by ID first
              const targetById = targetItems.find((item) => {
                if (!item) return false;
                const itemId =
                  item.video_tree_node_id ||
                  item.rich_text_node_id ||
                  item.form_tree_node_id ||
                  item.canvas_tree_node_id ||
                  item.attachment_tree_node_id;
                return itemId === targetItemId;
              });

              if (targetById) {
                const targetIndex = targetItems.indexOf(targetById);
                if (targetIndex !== -1) {
                  insertIndex =
                    moveType === "up" ? targetIndex : targetIndex + 1;
                }
              }
            }

            // If still no match, try by type and global number
            if (
              insertIndex === targetItems.length &&
              location.state.targetNodeGlobalNumber
            ) {
              const targetByType = targetItems.find((item) => {
                if (!item) return false;
                const itemType =
                  item.type ||
                  (item.video_tree_node_id
                    ? "video"
                    : item.rich_text_node_id
                    ? "richText"
                    : item.form_tree_node_id
                    ? "form"
                    : item.canvas_tree_node_id
                    ? "canvas"
                    : item.attachment_tree_node_id
                    ? "attachment"
                    : null);
                return itemType === targetItemType;
              });

              if (targetByType) {
                const targetIndex = targetItems.indexOf(targetByType);
                if (targetIndex !== -1) {
                  insertIndex =
                    moveType === "up" ? targetIndex : targetIndex + 1;
                }
              }
            }
          }

          targetItems.splice(insertIndex, 0, itemToMove);
        }

        updatedItems[targetContainerId] = targetItems;
        return updatedItems;
      }
    }

    // Continue with normal processing if we have enough items
    if (sourceNodeIndex >= visibleSourceItems.length) {
      // If we have any items, use the last item as a fallback
      if (visibleSourceItems.length > 0) {
        const adjustedIndex = visibleSourceItems.length - 1;
        sourceNodeIndex = adjustedIndex;
      } else {
        return updatedItems;
      }
    }

    let itemToMove = visibleSourceItems[sourceNodeIndex];
    if (!itemToMove) {
      console.error(
        `Failed to find ${nodeType} item at index ${sourceNodeIndex}`
      );
      return updatedItems;
    }

    const itemIndexInList = sourceItems.indexOf(itemToMove);
    if (itemIndexInList === -1) {
      return updatedItems;
    }

    if (createCopy) {
      // For copy, create a deep copy without removing from source
      const itemToMoveCopy = JSON.parse(JSON.stringify(itemToMove));

      // Generate new unique IDs
      const timestamp = Date.now();
      if (itemToMoveCopy.canvas_tree_node_id) {
        itemToMoveCopy.canvas_tree_node_id = `${itemToMoveCopy.canvas_tree_node_id}_copy_${timestamp}`;
      }
      if (itemToMoveCopy.rich_text_node_id) {
        itemToMoveCopy.rich_text_node_id = `${itemToMoveCopy.rich_text_node_id}_copy_${timestamp}`;
      }
      if (itemToMoveCopy.form_tree_node_id) {
        itemToMoveCopy.form_tree_node_id = `${itemToMoveCopy.form_tree_node_id}_copy_${timestamp}`;
      }
      if (itemToMoveCopy.attachment_tree_node_id) {
        itemToMoveCopy.attachment_tree_node_id = `${itemToMoveCopy.attachment_tree_node_id}_copy_${timestamp}`;
      }
      if (itemToMoveCopy.video_tree_node_id) {
        itemToMoveCopy.video_tree_node_id = `${itemToMoveCopy.video_tree_node_id}_copy_${timestamp}`;
      }

      // Use the copy for the target
      itemToMove = itemToMoveCopy;
    } else {
      // Remove from source
      sourceItems.splice(itemIndexInList, 1);
      updatedItems[sourceContainerId] = sourceItems;
    }

    // Prepare item for target
    if (isTargetSubstep) {
      itemToMove.substep_id_ref = targetContainerId;
      itemToMove.sub_step_tree_node_id = targetContainerId;
    } else {
      delete itemToMove.substep_id_ref;
      delete itemToMove.sub_step_tree_node_id;
    }

    const targetItems = updatedItems[targetContainerId] || [];

    if (moveType === "into") {
      targetItems.push(itemToMove);
    } else {
      // When moving above/below, we need to consider ALL items in the container, not just items of the same type
      const visibleTargetItems = targetItems.filter((item) => {
        const containerMatches = isTargetSubstep
          ? item.sub_step_tree_node_id === targetContainerId
          : !item.substep_id_ref && !item.sub_step_tree_node_id;
        return containerMatches;
      });

      let insertIndex = targetItems.length; // Default to end of list

      // Try to find the target item index if we have enough items
      if (targetNodeIndex < visibleTargetItems.length) {
        const targetItem = visibleTargetItems[targetNodeIndex];
        const targetItemIndex = targetItems.indexOf(targetItem);

        if (targetItemIndex !== -1) {
          if (moveType === "up") {
            insertIndex = targetItemIndex;
          } else if (moveType === "below") {
            insertIndex = targetItemIndex + 1;
          }
        } else {
        }
      } else {
        // If index is out of bounds, try a more flexible approach

        // Option 1: Use the first item of the target type if available
        if (visibleTargetItems.length > 0) {
          const firstItem = visibleTargetItems[0];
          const firstIndex = targetItems.indexOf(firstItem);
          if (firstIndex !== -1) {
            if (moveType === "up") {
              insertIndex = firstIndex;
            } else if (moveType === "below") {
              insertIndex = firstIndex + 1;
            }
          }
        } else {
        }
      }

      // Enhanced positioning logic for better accuracy
      if (insertIndex === targetItems.length && location.state.targetNodeType) {
        // Look for the target item by its type and properties
        const targetItemType = location.state.targetNodeType.toLowerCase();
        const targetItemId = location.state.targetNodeId;

        if (targetItemId) {
          // Try to find by ID first
          const targetById = targetItems.find((item) => {
            if (!item) return false;
            const itemId =
              item.video_tree_node_id ||
              item.rich_text_node_id ||
              item.form_tree_node_id ||
              item.canvas_tree_node_id ||
              item.attachment_tree_node_id;
            return itemId === targetItemId;
          });

          if (targetById) {
            const targetIndex = targetItems.indexOf(targetById);
            if (targetIndex !== -1) {
              insertIndex = moveType === "up" ? targetIndex : targetIndex + 1;
            }
          }
        }

        // If still no match, try by type and global number
        if (
          insertIndex === targetItems.length &&
          location.state.targetNodeGlobalNumber
        ) {
          const targetByType = targetItems.find((item) => {
            if (!item) return false;
            const itemType =
              item.type ||
              (item.video_tree_node_id
                ? "video"
                : item.rich_text_node_id
                ? "richText"
                : item.form_tree_node_id
                ? "form"
                : item.canvas_tree_node_id
                ? "canvas"
                : item.attachment_tree_node_id
                ? "attachment"
                : null);
            return itemType === targetItemType;
          });

          if (targetByType) {
            const targetIndex = targetItems.indexOf(targetByType);
            if (targetIndex !== -1) {
              insertIndex = moveType === "up" ? targetIndex : targetIndex + 1;
            }
          }
        }
      }

      targetItems.splice(insertIndex, 0, itemToMove);
    }

    updatedItems[targetContainerId] = targetItems;
    return updatedItems;
  };

  // Combine all content items for preview
  const allContentItems = {};

  Object.keys(updatedSteps).forEach((sectionId) => {
    updatedSteps[sectionId].forEach((step) => {
      const stepId = step.step_tree_node_id;

      // STEP-level content
      const stepContent = [
        ...(richTexts[stepId] || []).map((item) => ({
          ...item,
          type: "richText",
        })),
        ...(forms[stepId] || []).map((item) => ({
          ...item,
          type: "form",
        })),
        ...(attachments[stepId] || []).map((item) => ({
          ...item,
          type: "attachment",
        })),
        ...(canvases[stepId] || []).map((item) => ({
          ...item,
          type: "canvas",
        })),
        ...(videos[stepId] || []).map((item) => ({
          ...item,
          type: "video",
        })),
      ]
        .filter((item) => !item.substep_id_ref && !item.sub_step_tree_node_id)
        .sort((a, b) => {
          const orderA = a.sibling_order || a.procedure_tree?.sibling_order;
          const orderB = b.sibling_order || b.procedure_tree?.sibling_order;

          const orderCompare = compareSiblingOrders(orderA, orderB);
          if (orderCompare !== 0) return orderCompare;

          // Fallback: compare created_at
          const dateA = new Date(a.created_at);
          const dateB = new Date(b.created_at);
          return dateB - dateA; // latest comes first
        });

      allContentItems[stepId] = stepContent;

      // SUBSTEP-level content
      const substeps = substepsByStep[stepId] || [];
      substeps.forEach((substep) => {
        const substepId = substep.sub_step_tree_node_id;

        allContentItems[substepId] = [
          ...(richTexts[substepId] || []).map((item) => ({
            ...item,
            type: "richText",
          })),
          ...(forms[substepId] || []).map((item) => ({
            ...item,
            type: "form",
          })),
          ...(attachments[substepId] || []).map((item) => ({
            ...item,
            type: "attachment",
          })),
          ...(canvases[substepId] || []).map((item) => ({
            ...item,
            type: "canvas",
          })),
          ...(videos[substepId] || []).map((item) => ({
            ...item,
            type: "video",
          })),
        ].sort((a, b) => {
          const orderA = a.sibling_order || a.procedure_tree?.sibling_order;
          const orderB = b.sibling_order || b.procedure_tree?.sibling_order;

          const orderCompare = compareSiblingOrders(orderA, orderB);
          if (orderCompare !== 0) return orderCompare;

          // Fallback: compare created_at
          const dateA = new Date(a.created_at);
          const dateB = new Date(b.created_at);
          return dateB - dateA; // latest comes first
        });
      });
    });
  });

  const updatedAllContentItems = getReorganizedContentItems(
    allContentItems,
    location.state.sourceStepId,
    location.state.targetStepId,
    location.state.sourceNodeIndex,
    location.state.targetNodeIndex,
    moveType,
    location.state.sourceNodeType?.toLowerCase() || "canvas"
  );
  const updatedAttachments = {};
  const updatedRichTexts = {};
  const updatedForms = {};
  const updatedVideos = {};
  const updatedCanvases = {};

  Object.entries(updatedAllContentItems).forEach(([containerId, items]) => {
    updatedAttachments[containerId] = items.filter(
      (i) => i.type === "attachment"
    );
    updatedRichTexts[containerId] = items.filter((i) => i.type === "richText");
    updatedForms[containerId] = items.filter((i) => i.type === "form");
    updatedVideos[containerId] = items.filter((i) => i.type === "video");
    updatedCanvases[containerId] = items.filter((i) => i.type === "canvas");
  });

  return (
    <div style={{ position: "relative" }}>
      {/* Main Page Loader */}
      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "8px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            }}
          >
            <div
              style={{
                border: "4px solid #f3f3f3",
                borderRadius: "50%",
                width: "40px",
                height: "40px",
                animation: "spin 1s linear infinite",
                marginBottom: "10px",
              }}
            ></div>
            <div style={{ fontSize: "16px", color: "#333" }}>
              {createCopy ? "Copying canvas..." : "Moving canvas..."}
            </div>
          </div>
        </div>
      )}

      <ProcedureMoveAppBar
        selectedView={selectedView}
        showBackButton={false}
        setSelectedView={handleViewChange}
        title={
          createCopy
            ? "Please Confirm the Changes"
            : "Please Confirm the Changes"
        }
        buttons={[{ label: "Confirm", onClick: handleConfirm }]}
      />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "20px",
          padding: "8px 20",
          flexWrap: "wrap", // for responsiveness
        }}
      >
        {/* Checkbox + Title + Description */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              cursor: "pointer",
              margin: 0,
            }}
          >
            {/* <input type="checkbox" disabled={true} checked={false} /> */}
            <span style={{ fontSize: "20px", fontWeight: 600 }}>
              {type} {partNumber}
            </span>
          </label>

          {/* Description */}
        </div>

        {/* Right-aligned section */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "20px",
            marginLeft: "auto",
          }}
        >
          <div>
            <strong>Status: </strong>
            <span style={{ color: "orange" }}>{location.state.status}</span>
            {/* <span style={{ color: "orange" }}>{status}</span> */}
          </div>

          <div>
            <strong>Revision: </strong>
            <span>{revision}</span>
          </div>
        </div>
      </div>

      <div style={{ padding: "20px" }}>
        <div style={{ marginTop: "20px" }}>
          {sections.map((section, index) => {
            return (
              <div
                key={section.section_tree_node_id}
                style={{
                  margin: "20px 0",
                  clear: "both",
                }}
              >
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    cursor: "pointer",
                    clear: "both",
                  }}
                >
                  <h2 style={{ margin: 0 }}>Section {index + 1}</h2>
                </label>
                <hr />
                <hr />
                <div>{section.section_name}</div>
                <div>{section.short_description}</div>

                {/* Steps for this section */}
                {(updated[section.section_tree_node_id] || []).map(
                  (step, stepIndex) => {
                    const stepId = step.step_tree_node_id;
                    const sectionId = section.section_tree_node_id;
                    stepCounter++;
                    const stepsBeforeThisSection = previewSections
                      .slice(0, index)
                      .reduce(
                        (acc, s) =>
                          acc + (updated[s.section_tree_node_id]?.length || 0),
                        0
                      );
                    const globalStepNumber =
                      stepsBeforeThisSection + stepIndex + 1;

                    const currentRichTextCounter = richTextCounter;

                    // Update counters for next step
                    //attachmentCounter += myAttachments.length;
                    // videoCounter += myVideos.length;
                    // formCounter += myForms.length;
                    // canvasCounter += myCanvases.length;
                    // richTextCounter += myRichTexts.length; // If you're adding one richText per step

                    richTextsCounter[stepId] = currentRichTextCounter;

                    // Choose which data to display based on selectedView
                    const displayedRichTexts =
                      selectedView === "new" ? updatedRichTexts : richTexts;
                    const displayedForms =
                      selectedView === "new" ? updatedForms : forms;
                    const displayedAttachments =
                      selectedView === "new" ? updatedAttachments : attachments;
                    const displayedCanvases =
                      selectedView === "new" ? updatedCanvases : canvases;
                    const displayedVideos =
                      selectedView === "new" ? updatedVideos : videos;

                    // Use the selected content arrays for preview
                    const combinedItems =
                      selectedView === "new"
                        ? updatedAllContentItems[stepId] || []
                        : allContentItems[stepId] || []; // Filter out substeps or unwanted items (same as your current filter)
                    const filteredItems = combinedItems.filter(
                      (item) =>
                        !item.substep_id_ref && !item.sub_step_tree_node_id
                    );

                    // Store the section index to use in the inner loop
                    const currentSectionIndex = index;

                    // filteredItems.sort((a, b) => {
                    //   const orderA =
                    //     a.sibling_order || a.procedure_tree?.sibling_order;
                    //   const orderB =
                    //     b.sibling_order || b.procedure_tree?.sibling_order;

                    //   const orderCompare = compareSiblingOrders(orderA, orderB);
                    //   if (orderCompare !== 0) return orderCompare;

                    //   // Fallback: compare created_at
                    //   const dateA = new Date(a.created_at);
                    //   const dateB = new Date(b.created_at);
                    //   return dateB - dateA; // latest comes first
                    // });

                    return (
                      <div
                        key={stepId}
                        style={{ marginTop: "20px", clear: "both" }}
                      >
                        <label>
                          <HeadingWithTreePath
                            title={`Step ${globalStepNumber}`}
                            treePathParams={{
                              sectionIndex: currentSectionIndex,
                              stepIndex: globalStepNumber - 1,
                              substepIndex: undefined,
                              nodeType: undefined,
                              nodeIndex: undefined,
                            }}
                          >
                            {location.state.movingStep &&
                              steps &&
                              steps.length > 0 &&
                              (step.step_tree_node_id ===
                                steps[0].step_tree_node_id ||
                                (section.section_tree_node_id ===
                                  sortedSections[targetSectionIndex]
                                    ?.section_tree_node_id &&
                                  ((moveType === "up" &&
                                    stepIndex === targetStepIndex) ||
                                    (moveType === "below" &&
                                      stepIndex === targetStepIndex + 1) ||
                                    (moveType === "into" &&
                                      stepIndex ===
                                        (
                                          updated[
                                            section.section_tree_node_id
                                          ] || []
                                        ).length -
                                          1)))) && (
                                <span
                                  style={{
                                    fontSize: "16px",
                                    color: "#007bff",
                                    marginLeft: "10px",
                                    fontStyle: "italic",
                                    clear: "both",
                                  }}
                                >
                                  {step.step_tree_node_id ===
                                  location.state.fromStepId
                                    ? createCopy
                                      ? "(Copying)"
                                      : "(Moving)"
                                    : "(New Position)"}
                                </span>
                              )}
                          </HeadingWithTreePath>
                        </label>
                        <hr />
                        <p style={{ whiteSpace: 'pre-wrap' }}>{step.short_description || ""}</p>
                        <p>
                          <p>
                            {structuredClone(step.step_details)
                              .sort(
                                (a, b) =>
                                  new Date(a.created_at) -
                                  new Date(b.created_at)
                              )
                              .map((myStep) => {
                                const partNumber =
                                  myStep.part_info?.part_number || "";
                                const description =
                                  myStep.part_info?.description || "";
                                const qtyText =
                                  myStep.qty && myStep.qty != 0
                                    ? `Qty ${myStep.qty}`
                                    : "";

                                const partText = partNumber
                                  ? ` (${partNumber})`
                                  : "";

                                return (
                                  <>
                                    {myStep.action}
                                    {partText}{" "}
                                    <RenderHtml content={description} />{" "}
                                    {qtyText}&nbsp;
                                  </>
                                );
                              })}
                          </p>
                        </p>

                        <h4>
                          {step.bom_table_title_info?.category_name || ""}
                        </h4>

                        <table className="table">
                          <thead>
                            <tr>
                              <th>Type</th>
                              <th>
                                {
                                  step.part_number_column_title_ref_info
                                    ?.category_name
                                }{" "}
                              </th>
                              <th>Description</th>
                              <th>Qty Per</th>
                              <th>Unit</th>
                            </tr>
                          </thead>

                          <tbody>
                            {step.parts_required.map((row) => (
                              <tr>
                                <td>{row.part_info.type_info.name}</td>
                                <td>{row.part_info.part_number}</td>
                                <td>
                                  <RenderHtml
                                    content={row.part_info.description}
                                  />{" "}
                                </td>
                                <td>{row.qty === 0 ? "" : row.qty}</td>
                                <td>{row.part_info?.unit_info?.unit_name}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>

                        {/* Step Content */}

                        {filteredItems.map((item, index) => {
                          if (item.substep_id_ref || item.sub_step_tree_node_id)
                            return null;
                          switch (item.type) {
                            case "richText": {
                              const globalRichTextNumber = richTextCounter++; // ✅ use then increment
                              // render richText block here
                              const label = (
                                <HeadingWithTreePath
                                  title={`Rich Text ${globalRichTextNumber}`}
                                  treePathParams={{
                                    sectionIndex: currentSectionIndex,
                                    stepIndex: globalStepNumber - 1,
                                    substepIndex: undefined,
                                    nodeType: "richText",
                                    nodeIndex: globalRichTextNumber - 1,
                                  }}
                                />
                              );

                              return (
                                <div
                                  key={
                                    item.rich_text_node_id ||
                                    `richText-${globalRichTextNumber}`
                                  }
                                  style={{ marginTop: "20px", clear: "both" }}
                                >
                                  <label
                                    style={{
                                      display: "flex",
                                      gap: "6px",
                                      cursor: "pointer",
                                      clear: "both",
                                    }}
                                  >
                                    {label}
                                  </label>

                                  <div
                                    style={{
                                      marginLeft: "5px",
                                      marginTop: "-10px",
                                      clear: "both",
                                    }}
                                  >
                                    {item.short_description}
                                  </div>
                                  {item.category_data && (
                                    <div
                                      style={{
                                        marginLeft: "4px",
                                        marginTop: "10px",
                                        clear: "both",
                                      }}
                                    >
                                      {item.category_data.category_name}
                                    </div>
                                  )}
                                  <div
                                    style={{
                                      fontSize: "14px",
                                      marginLeft: "4px",
                                      marginTop: "5px",
                                      clear: "both",
                                    }}
                                  >
                                    <div
                                      style={{
                                        marginTop: "-6px",
                                        clear: "both",
                                      }}
                                      dangerouslySetInnerHTML={{
                                        __html: item.rich_text_content,
                                      }}
                                    />
                                  </div>
                                </div>
                              );
                            }
                            case "video": {
                              const globalVideoNumber = videoCounter++; // ✅ use then increment
                              const label = (
                                <HeadingWithTreePath
                                  title={`Video ${globalVideoNumber}`}
                                  treePathParams={{
                                    sectionIndex: currentSectionIndex,
                                    stepIndex: globalStepNumber - 1,
                                    substepIndex: undefined,
                                    nodeType: "video",
                                    nodeIndex: globalVideoNumber - 1,
                                  }}
                                />
                              );

                              return (
                                <div
                                  key={
                                    item.video_tree_node_id ||
                                    `video-${globalVideoNumber}`
                                  }
                                  style={{ marginTop: "20px", clear: "both" }}
                                >
                                  <label
                                    style={{
                                      display: "flex",
                                      gap: "6px",
                                      cursor: "pointer",
                                      clear: "both",
                                    }}
                                  >
                                    {label}
                                  </label>

                                  {renderVideo(item)}

                                  <div>{item.video_url}</div>

                                  <div style={{ whiteSpace: 'pre-wrap' }}>{item.short_description}</div>
                                </div>
                              );
                            }

                            case "form": {
                              const globalFormNumber = formCounter++; // ✅ use then increment
                              const label = (
                                <HeadingWithTreePath
                                  title={`Form ${globalFormNumber}`}
                                  treePathParams={{
                                    sectionIndex: currentSectionIndex,
                                    stepIndex: globalStepNumber - 1,
                                    substepIndex: undefined,
                                    nodeType: "form",
                                    nodeIndex: globalFormNumber - 1,
                                  }}
                                />
                              );
                              // render form block here
                              return (
                                <div
                                  key={
                                    item.form_tree_node_id ||
                                    `form-${globalFormNumber}`
                                  }
                                  style={{ marginTop: "20px", clear: "both" }}
                                >
                                  <label
                                    style={{
                                      display: "flex",
                                      gap: "6px",
                                      cursor: "pointer",
                                      marginTop: "20px",
                                      clear: "both",
                                    }}
                                  >
                                    {label}
                                  </label>
                                  <div>{item.short_description}</div>
                                </div>
                              );
                            }
                            case "canvas": {
                              const pages = getPages(item);

                              const globalCanvasNumber = canvasCounter++; // ✅ use then increment
                              // Find the local index of this canvas within the current step
                              const canvasItems = filteredItems.filter(
                                (item) => item.type === "canvas"
                              );
                              const localCanvasIndex = canvasItems.findIndex(
                                (canvas) =>
                                  canvas.canvas_tree_node_id ===
                                  item.canvas_tree_node_id
                              );
                              const label = (
                                <HeadingWithTreePath
                                  title={`Canvas ${globalCanvasNumber}`}
                                  treePathParams={{
                                    sectionIndex: currentSectionIndex,
                                    stepIndex: globalStepNumber - 1,
                                    substepIndex: undefined,
                                    nodeType: "canvas",
                                    nodeIndex: globalCanvasNumber - 1,
                                  }}
                                />
                              );
                              const shapes = item.shapes || [];

                              return (
                                <div
                                  key={
                                    item.canvas_tree_node_id ||
                                    `canvas-${globalCanvasNumber}`
                                  }
                                  style={{ marginTop: "40px", clear: "both" }}
                                >
                                  <label
                                    style={{
                                      display: "flex",
                                      gap: "6px",
                                      cursor: "pointer",
                                      clear: "both",
                                    }}
                                  >
                                    {label}
                                  </label>
                                  {/* Add the canvas description here */}
                                  <div
                                    style={{
                                      marginBottom: "10px",
                                      clear: "both",
                                    }}
                                  >
                                    {item.short_description}
                                  </div>
                                  {/* Display all pages vertically to ensure visibility */}
                                  <CanvasDisplay pages={pages} />
                                </div>
                              );
                            }
                            case "attachment": {
                              const attachmentList = item.attachments || [];
                              if (attachmentList.length === 0) return null;

                              //  const globalAttachmentNumber =
                              //           attachmentCounter++; // ✅ use then increment
                              const globalAttachmentNumber =
                                attachmentCounter++; // ✅ Increment here per attachment
                              const label = (
                                <HeadingWithTreePath
                                  title={`Attachment ${globalAttachmentNumber}`}
                                  treePathParams={{
                                    sectionIndex: currentSectionIndex,
                                    stepIndex: globalStepNumber - 1,
                                    substepIndex: undefined,
                                    nodeType: "attachment",
                                    nodeIndex: globalAttachmentNumber - 1,
                                  }}
                                />
                              );

                              return (
                                <div
                                  key={
                                    item.attachment_tree_node_id ||
                                    `attachment-${globalAttachmentNumber}-${index}`
                                  }
                                  style={{ marginTop: "20px", clear: "both" }}
                                >
                                  <label
                                    style={{
                                      display: "flex",
                                      gap: "6px",
                                      cursor: "pointer",
                                      marginTop: "20px",
                                      clear: "both",
                                    }}
                                  >
                                    {label}
                                  </label>
                                  <div>{item.short_description}</div>
                                  {attachmentList.map((attachment, i) => (
                                    <div
                                      key={`${
                                        item.attachment_tree_node_id ||
                                        `attachment-${globalAttachmentNumber}`
                                      }-${i}`}
                                      style={{
                                        marginLeft: "20px",
                                        clear: "both",
                                      }}
                                    >
                                      {renderPreview(attachment)}
                                    </div>
                                  ))}
                                </div>
                              );
                            }
                            default:
                              return null;
                          }
                        })}

                        {/* Substeps */}
                        {(updatedSubstepsByStep[stepId] || []).map(
                          (substep, substepIndex) => {
                            const substepId = substep.sub_step_tree_node_id;
                            // Choose content based on view mode
                            const combinedItems =
                              selectedView === "new"
                                ? updatedAllContentItems[substepId] || []
                                : allContentItems[substepId] || [];

                            const filteredItems = combinedItems;

                            // Global step number calculation based on the updated steps data
                            const stepsBeforeThisOne =
                              previewSections
                                .slice(0, index)
                                .reduce((sectionAcc, s) => {
                                  const steps =
                                    updated[s.section_tree_node_id] || [];
                                  return sectionAcc + steps.length;
                                }, 0) + stepIndex;

                            const globalStepNumber = stepsBeforeThisOne + 1;

                            // Final substep label like Substep 5A
                            const substepLetter = String.fromCharCode(
                              65 + substepIndex
                            ); // A, B, C, ...

                            const globalSubstepLabel = `Substep ${globalStepNumber}${substepLetter}`;

                            return (
                              <div
                                key={substepId}
                                style={{ marginTop: "20px", clear: "both" }}
                              >
                                <div>
                                  <HeadingWithTreePath
                                    title={globalSubstepLabel}
                                    treePathParams={{
                                      sectionIndex: index,
                                      stepIndex: globalStepNumber - 1,
                                      substepIndex: substepIndex,
                                      nodeType: undefined,
                                      nodeIndex: undefined,
                                    }}
                                  />
                                  <div style={{ whiteSpace: 'pre-wrap' }}>{substep.short_description}</div>
                                </div>

                                {/* Substep Rich Texts */}
                                {filteredItems.map((item, index) => {
                                  switch (item.type) {
                                    case "richText": {
                                      const globalRichTextNumber =
                                        richTextCounter++; // ✅ use then increment
                                      // render richText block here
                                      const label = (
                                        <HeadingWithTreePath
                                          title={`Rich Text ${globalRichTextNumber}`}
                                          treePathParams={{
                                            sectionIndex: currentSectionIndex,
                                            stepIndex: globalStepNumber - 1,
                                            substepIndex: substepIndex,
                                            nodeType: "richText",
                                            nodeIndex: globalRichTextNumber - 1,
                                          }}
                                        />
                                      );

                                      return (
                                        <div
                                          key={
                                            item.rich_text_node_id ||
                                            `richText-${globalRichTextNumber}`
                                          }
                                          style={{ marginTop: "20px" }}
                                        >
                                          <label
                                            style={{
                                              display: "flex",
                                              gap: "6px",
                                              cursor: "pointer",
                                              clear: "both",
                                            }}
                                          >
                                            {label}
                                          </label>

                                          <div
                                            style={{
                                              marginLeft: "5px",
                                              marginTop: "-10px",
                                              clear: "both",
                                            }}
                                          >
                                            {item.short_description}
                                          </div>
                                          {item.category_data && (
                                            <div
                                              style={{
                                                marginLeft: "4px",
                                                marginTop: "10px",
                                                clear: "both",
                                              }}
                                            >
                                              {item.category_data.category_name}
                                            </div>
                                          )}
                                          <div
                                            style={{
                                              fontSize: "14px",
                                              marginLeft: "4px",
                                              marginTop: "5px",
                                              clear: "both",
                                            }}
                                          >
                                            <div
                                              style={{
                                                marginTop: "-6px",
                                                clear: "both",
                                              }}
                                              dangerouslySetInnerHTML={{
                                                __html: item.rich_text_content,
                                              }}
                                            />
                                          </div>
                                        </div>
                                      );
                                    }
                                    case "video": {
                                      const globalVideoNumber = videoCounter++; // ✅ use then increment
                                      const label = (
                                        <HeadingWithTreePath
                                          title={`Video ${globalVideoNumber}`}
                                          treePathParams={{
                                            sectionIndex: currentSectionIndex,
                                            stepIndex: globalStepNumber - 1,
                                            substepIndex: substepIndex,
                                            nodeType: "video",
                                            nodeIndex: globalVideoNumber - 1,
                                          }}
                                        />
                                      );

                                      return (
                                        <div
                                          key={
                                            item.video_tree_node_id ||
                                            `video-${globalVideoNumber}`
                                          }
                                          style={{
                                            marginTop: "20px",
                                            clear: "both",
                                          }}
                                        >
                                          <label
                                            style={{
                                              display: "flex",
                                              gap: "6px",
                                              cursor: "pointer",
                                              clear: "both",
                                            }}
                                          >
                                            {label}
                                          </label>

                                          {renderVideo(item)}

                                          <div>{item.video_url}</div>

                                          <div>{item.short_description}</div>
                                        </div>
                                      );
                                    }

                                    case "form": {
                                      const globalFormNumber = formCounter++; // ✅ use then increment
                                      const label = (
                                        <HeadingWithTreePath
                                          title={`Form ${globalFormNumber}`}
                                          treePathParams={{
                                            sectionIndex: currentSectionIndex,
                                            stepIndex: globalStepNumber - 1,
                                            substepIndex: substepIndex,
                                            nodeType: "form",
                                            nodeIndex: globalFormNumber - 1,
                                          }}
                                        />
                                      );
                                      // render form block here
                                      return (
                                        <div
                                          key={
                                            item.form_tree_node_id ||
                                            `form-${globalFormNumber}`
                                          }
                                          style={{
                                            marginTop: "20px",
                                            clear: "both",
                                          }}
                                        >
                                          <label
                                            style={{
                                              display: "flex",
                                              gap: "6px",
                                              cursor: "pointer",
                                              marginTop: "20px",
                                              clear: "both",
                                            }}
                                          >
                                            {label}
                                          </label>
                                          <div>{item.short_description}</div>
                                        </div>
                                      );
                                    }
                                    case "canvas": {
                                      const pages = getPages(item);

                                      const globalCanvasNumber =
                                        canvasCounter++; // ✅ use then increment
                                      // Find the local index of this canvas within the current substep
                                      const canvasItems = filteredItems.filter(
                                        (item) => item.type === "canvas"
                                      );
                                      const localCanvasIndex =
                                        canvasItems.findIndex(
                                          (canvas) =>
                                            canvas.canvas_tree_node_id ===
                                            item.canvas_tree_node_id
                                        );
                                      const label = (
                                        <HeadingWithTreePath
                                          title={`Canvas ${globalCanvasNumber}`}
                                          treePathParams={{
                                            sectionIndex: currentSectionIndex,
                                            stepIndex: globalStepNumber - 1,
                                            substepIndex: substepIndex,
                                            nodeType: "canvas",
                                            nodeIndex: globalCanvasNumber - 1,
                                          }}
                                        />
                                      );
                                      const shapes = item.shapes || [];

                                      return (
                                        <div
                                          key={
                                            item.canvas_tree_node_id ||
                                            `canvas-${globalCanvasNumber}`
                                          }
                                          style={{
                                            marginTop: "40px",
                                            clear: "both",
                                          }}
                                        >
                                          <label
                                            style={{
                                              display: "flex",
                                              gap: "6px",
                                              cursor: "pointer",
                                              clear: "both",
                                            }}
                                          >
                                            {label}
                                          </label>
                                          {/* Add the canvas description here */}
                                          <div
                                            style={{
                                              marginBottom: "10px",
                                              clear: "both",
                                            }}
                                          >
                                            {item.short_description}
                                          </div>
                                          {/* Display all pages vertically to ensure visibility */}
                                          <CanvasDisplay pages={pages} />
                                        </div>
                                      );
                                    }
                                    case "attachment": {
                                      const attachmentList =
                                        item.attachments || [];
                                      if (attachmentList.length === 0)
                                        return null;

                                      //  const globalAttachmentNumber =
                                      //           attachmentCounter++; // ✅ use then increment
                                      const globalAttachmentNumber =
                                        attachmentCounter++; // ✅ Increment here per attachment
                                      const label = (
                                        <HeadingWithTreePath
                                          title={`Attachment ${globalAttachmentNumber}`}
                                          treePathParams={{
                                            sectionIndex: currentSectionIndex,
                                            stepIndex: globalStepNumber - 1,
                                            substepIndex: undefined,
                                            nodeType: "attachment",
                                            nodeIndex:
                                              globalAttachmentNumber - 1,
                                          }}
                                        />
                                      );

                                      return (
                                        <div
                                          key={
                                            item.attachment_tree_node_id ||
                                            `substep-attachment-${globalAttachmentNumber}`
                                          }
                                          style={{
                                            marginTop: "20px",
                                            clear: "both",
                                          }}
                                        >
                                          <label
                                            style={{
                                              display: "flex",
                                              gap: "6px",
                                              cursor: "pointer",
                                              marginTop: "20px",
                                              clear: "both",
                                            }}
                                          >
                                            {label}
                                          </label>
                                          <div>{item.short_description}</div>
                                          {attachmentList.map(
                                            (attachment, i) => (
                                              <div
                                                key={`${
                                                  item.attachment_tree_node_id ||
                                                  `substep-attachment-${globalAttachmentNumber}`
                                                }-${i}`}
                                                style={{
                                                  marginLeft: "20px",
                                                  clear: "both",
                                                }}
                                              >
                                                {renderPreview(attachment)}
                                              </div>
                                            )
                                          )}
                                        </div>
                                      );
                                    }
                                    default:
                                      return null;
                                  }
                                })}
                              </div>
                            );
                          }
                        )}
                      </div>
                    );
                  }
                )}
              </div>
            );
          })}
        </div>
      </div>
      {/* Remove old loader position */}
      {/* {isLoading && <Loader text="Saving step..." />} */}
      {snackbar.open && (
        <Snackbar
          message={snackbar.message}
          type={snackbar.type}
          onClose={handleCloseSnackbar}
        />
      )}

      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content_addsection">
            {/* Header */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              <h4
                style={{
                  marginLeft: "23px",
                  fontSize: "18px",
                  color: "#333333",
                }}
              >
                {createCopy
                  ? generateConfirmMoveMessage({
                      locationState: location.state,
                      nodeType: "Canvas",
                      moveType,
                      sourceStepIndex,
                      targetStepIndex,
                      targetSectionData,
                      sourceSectionIndex,
                      targetSectionIndex,
                    }).replace("Confirm Move", "Confirm Copy")
                  : generateConfirmMoveMessage({
                      locationState: location.state,
                      nodeType: "Canvas",
                      moveType,
                      sourceStepIndex,
                      targetStepIndex,
                      targetSectionData,
                      sourceSectionIndex,
                      targetSectionIndex,
                    })}
              </h4>
              <button
                onClick={() => setModalOpen(false)}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "10px",
                  background: "none",
                  border: "none",
                  fontSize: "20px",
                  cursor: "pointer",
                  color: "#666",
                }}
              >
                ✕
              </button>
            </div>

            {/* Modal Body */}
            <div
              style={{ padding: "24px", marginTop: "-28px", color: "#333333" }}
            >
              <h4 style={{ fontSize: "16px" }}>
                For {type} {partNumber} - Rev {revision}
              </h4>

              <p style={{ fontSize: "16px", color: "#333333" }}>
                <strong>Editor:</strong>{" "}
                <span style={{ marginLeft: "10px" }}>
                  {localStorage.getItem("user_name")}
                </span>
              </p>

              <label
                className="modal-label"
                style={{ fontSize: "16px", color: "#333333" }}
              >
                Comment<span className="required">*</span>
              </label>
              <textarea
                className="modal-textarea"
                placeholder="Enter your comments here..."
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                style={{
                  width: "100%",
                  minHeight: "100px",
                  padding: "8px",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                }}
                disabled={isLoading}
              ></textarea>
            </div>

            {/* Footer */}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                padding: "16px 24px",
                borderTop: "1px solid #e0e0e0",
                marginTop: "-10px",
                position: "relative",
              }}
            >
              {isModalLoading && (
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "rgba(255, 255, 255, 0.7)",
                    zIndex: 10,
                  }}
                >
                  <div
                    className="loader-spinner"
                    style={{
                      border: "4px solid #f3f3f3",
                      borderRadius: "50%",
                      width: "20px",
                      height: "20px",
                      animation: "spin 1s linear infinite",
                      marginRight: "10px",
                    }}
                  ></div>
                  <span>Processing...</span>
                </div>
              )}
              <button
                onClick={() => setModalOpen(false)}
                style={{
                  padding: "8px 16px",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  background: "#6c757d",
                  color: "#e9ecef",
                  cursor: isModalLoading ? "not-allowed" : "pointer",
                }}
                disabled={isModalLoading}
              >
                Close
              </button>
              <button
                onClick={handleConfirmSave}
                style={{
                  padding: "8px 16px",
                  border: "1px solid #007bff",
                  borderRadius: "4px",
                  background: "#007bff",
                  color: "white",
                  cursor: isModalLoading ? "not-allowed" : "pointer",
                  opacity: isModalLoading ? 0.7 : 1,
                }}
                disabled={isModalLoading}
              >
                {isModalLoading
                  ? createCopy
                    ? "Copying..."
                    : "Moving..."
                  : createCopy
                  ? "Copy"
                  : "Move"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProcedureCanvasMovePreview;
